import config from "@/config/config";
import { authAdapter } from "@/core/auth/adapter";
import { addToast } from "@heroui/react";
import { authExchange } from "@urql/exchange-auth";
import { Client, cacheExchange, errorExchange, fetchExchange } from "urql";

const adapterAuthExchange = authExchange(async (utils) => {
	return {
		addAuthToOperation(operation) {
			if (operation.context?.skipAuth) return operation;
			const token = authAdapter.getToken();
			if (!token) return operation;
			return utils.appendHeaders(operation, { Authorization: `Bearer ${token}` });
		},
		didAuthError(error) {
			return error.response?.status === 401;
		},
		async refreshAuth() {
			await authAdapter.refresh();
		},
	};
});

// biome-ignore lint/suspicious/noExplicitAny: urql error shapes are untyped
function extractGraphQLErrorMessage(error: any): string {
	return (
		error?.graphQLErrors?.[0]?.extensions?.errors?.[0]?.message ??
		error?.graphQLErrors?.[0]?.message ??
		error?.message ??
		"An unexpected error occurred"
	);
}

export const urqlClient = new Client({
	url: config.BACKEND_ENDPOINT,
	exchanges: [
		cacheExchange,
		adapterAuthExchange,
		errorExchange({
			onError(error) {
				const message = extractGraphQLErrorMessage(error);
				const isTokenExpired =
					message.includes("token is expired") || message.includes('exp" not satisfied');

				if (!isTokenExpired) {
					addToast({ title: "Error", description: message, color: "danger" });
				}
				console.error("GraphQL Error:", message, error);
			},
		}),
		fetchExchange,
	],
});
